module.exports = __webpack_public_path__ + "html/add-block.component.html";